import React from 'react';

const SingleSelect = () => (
  <svg
    width="164"
    height="96"
    viewBox="0 0 164 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-describedby="single-select-title"
  >
    <title id="single-select-title">Single Select Preview</title>
    <g clipPath="url(#clip0)">
      <rect width="164" height="96" rx="4" fill="#ECF2FF" />
      <g filter="url(#filter0_dd)">
        <rect
          x="23"
          y="8"
          width="166.718"
          height="94.232"
          rx="1.81215"
          fill="white"
        />
        <rect
          x="23.2265"
          y="8.22652"
          width="166.265"
          height="93.779"
          rx="1.58564"
          stroke="#F1F2F5"
          strokeWidth="0.453039"
        />
      </g>
      <rect
        x="37.3611"
        y="39.3611"
        width="117.722"
        height="25.2778"
        rx="1.08333"
        fill="white"
      />
      <g clipPath="url(#clip1)">
        <path
          d="M54.4831 50.5245C54.2677 49.1765 53.212 48.3886 51.8794 48.3886C50.2483 48.3886 49.0449 49.6105 49.0449 51.6263C49.0449 53.6422 50.2421 54.864 51.8794 54.864C53.2643 54.864 54.2769 53.9961 54.4831 52.7497L53.5229 52.7466C53.3598 53.5529 52.6827 53.9961 51.8856 53.9961C50.8053 53.9961 49.9897 53.1682 49.9897 51.6263C49.9897 50.0967 50.8022 49.2565 51.8886 49.2565C52.6919 49.2565 53.3659 49.7089 53.5229 50.5245H54.4831ZM56.4674 51.971C56.4674 51.217 56.9445 50.7861 57.6 50.7861C58.234 50.7861 58.6125 51.1893 58.6125 51.8818V54.7778H59.5328V51.771C59.5328 50.5922 58.8865 49.989 57.9139 49.989C57.1784 49.989 56.7352 50.3091 56.5136 50.82H56.4551V48.4748H55.5472V54.7778H56.4674V51.971ZM62.752 54.8732C64.0846 54.8732 64.9556 53.8976 64.9556 52.4357C64.9556 50.9646 64.0846 49.989 62.752 49.989C61.4194 49.989 60.5484 50.9646 60.5484 52.4357C60.5484 53.8976 61.4194 54.8732 62.752 54.8732ZM62.7551 54.1007C61.8841 54.1007 61.4778 53.3406 61.4778 52.4327C61.4778 51.5278 61.8841 50.7584 62.7551 50.7584C63.6199 50.7584 64.0261 51.5278 64.0261 52.4327C64.0261 53.3406 63.6199 54.1007 62.7551 54.1007ZM67.974 54.8732C69.3066 54.8732 70.1776 53.8976 70.1776 52.4357C70.1776 50.9646 69.3066 49.989 67.974 49.989C66.6414 49.989 65.7704 50.9646 65.7704 52.4357C65.7704 53.8976 66.6414 54.8732 67.974 54.8732ZM67.9771 54.1007C67.1061 54.1007 66.6998 53.3406 66.6998 52.4327C66.6998 51.5278 67.1061 50.7584 67.9771 50.7584C68.8419 50.7584 69.2481 51.5278 69.2481 52.4327C69.2481 53.3406 68.8419 54.1007 67.9771 54.1007ZM74.7471 51.2047C74.5563 50.4691 73.9808 49.989 72.959 49.989C71.8911 49.989 71.134 50.5522 71.134 51.3893C71.134 52.0603 71.5402 52.5065 72.4266 52.7035L73.2268 52.8789C73.6823 52.9805 73.8946 53.1836 73.8946 53.4791C73.8946 53.8453 73.5038 54.1315 72.9005 54.1315C72.3496 54.1315 71.9957 53.8945 71.8849 53.4298L70.9955 53.5652C71.1494 54.4024 71.8449 54.8732 72.9067 54.8732C74.0485 54.8732 74.8395 54.2669 74.8395 53.4114C74.8395 52.7435 74.4147 52.3311 73.5468 52.1311L72.7959 51.9587C72.2758 51.8356 72.0511 51.6602 72.0542 51.3401C72.0511 50.9769 72.445 50.7184 72.9682 50.7184C73.5407 50.7184 73.8054 51.0354 73.9131 51.3524L74.7471 51.2047ZM77.8886 54.8732C78.9197 54.8732 79.6491 54.3654 79.8583 53.596L78.9874 53.4391C78.8212 53.8853 78.4211 54.1131 77.8979 54.1131C77.11 54.1131 76.5806 53.6022 76.556 52.6912H79.9168V52.365C79.9168 50.6569 78.895 49.989 77.824 49.989C76.5068 49.989 75.6389 50.9923 75.6389 52.445C75.6389 53.913 76.4945 54.8732 77.8886 54.8732ZM76.5591 52.0018C76.596 51.3309 77.0823 50.7492 77.8302 50.7492C78.5442 50.7492 79.012 51.2785 79.0151 52.0018H76.5591ZM85.2227 54.8732C86.5553 54.8732 87.4263 53.8976 87.4263 52.4357C87.4263 50.9646 86.5553 49.989 85.2227 49.989C83.8901 49.989 83.0191 50.9646 83.0191 52.4357C83.0191 53.8976 83.8901 54.8732 85.2227 54.8732ZM85.2258 54.1007C84.3548 54.1007 83.9485 53.3406 83.9485 52.4327C83.9485 51.5278 84.3548 50.7584 85.2258 50.7584C86.0906 50.7584 86.4968 51.5278 86.4968 52.4327C86.4968 53.3406 86.0906 54.1007 85.2258 54.1007ZM88.4535 56.5506H89.3737V54.0423H89.4291C89.5953 54.3439 89.9338 54.8702 90.7955 54.8702C91.9404 54.8702 92.7714 53.953 92.7714 52.4234C92.7714 50.8908 91.9281 49.989 90.7863 49.989C89.9092 49.989 89.5922 50.5245 89.4291 50.8169H89.3521V50.0506H88.4535V56.5506ZM89.3552 52.4142C89.3552 51.4263 89.7861 50.7707 90.5893 50.7707C91.4234 50.7707 91.8419 51.4755 91.8419 52.4142C91.8419 53.3621 91.4111 54.0854 90.5893 54.0854C89.7984 54.0854 89.3552 53.4083 89.3552 52.4142ZM96.0091 50.0506H95.0396V48.918H94.1194V50.0506H93.4269V50.7892H94.1194V53.5806C94.1163 54.4393 94.7719 54.8548 95.4982 54.8394C95.7906 54.8363 95.9875 54.7809 96.0953 54.7409L95.9291 53.9807C95.8675 53.993 95.7536 54.0207 95.6059 54.0207C95.3074 54.0207 95.0396 53.9222 95.0396 53.3898V50.7892H96.0091V50.0506ZM97.027 54.7778H97.9472V50.0506H97.027V54.7778ZM97.4917 49.3212C97.8087 49.3212 98.0734 49.0749 98.0734 48.7733C98.0734 48.4717 97.8087 48.2224 97.4917 48.2224C97.1717 48.2224 96.9101 48.4717 96.9101 48.7733C96.9101 49.0749 97.1717 49.3212 97.4917 49.3212ZM101.176 54.8732C102.509 54.8732 103.38 53.8976 103.38 52.4357C103.38 50.9646 102.509 49.989 101.176 49.989C99.8438 49.989 98.9729 50.9646 98.9729 52.4357C98.9729 53.8976 99.8438 54.8732 101.176 54.8732ZM101.18 54.1007C100.309 54.1007 99.9023 53.3406 99.9023 52.4327C99.9023 51.5278 100.309 50.7584 101.18 50.7584C102.044 50.7584 102.451 51.5278 102.451 52.4327C102.451 53.3406 102.044 54.1007 101.18 54.1007ZM105.327 51.971C105.327 51.217 105.789 50.7861 106.429 50.7861C107.054 50.7861 107.433 51.1954 107.433 51.8818V54.7778H108.353V51.771C108.353 50.6015 107.71 49.989 106.743 49.989C106.032 49.989 105.568 50.3183 105.349 50.82H105.291V50.0506H104.407V54.7778H105.327V51.971Z"
          fill="#696E7C"
        />
        <path
          d="M141.52 54.7301C141.419 54.8317 141.281 54.8889 141.137 54.889H140.863C140.72 54.8873 140.582 54.8304 140.48 54.7301L136.775 51.0179C136.707 50.9501 136.668 50.8578 136.668 50.7615C136.668 50.6652 136.707 50.5729 136.775 50.5051L137.288 49.9923C137.354 49.9244 137.445 49.8861 137.541 49.8861C137.636 49.8861 137.727 49.9244 137.793 49.9923L141 53.2062L144.207 49.9923C144.275 49.924 144.367 49.8855 144.463 49.8855C144.559 49.8855 144.652 49.924 144.719 49.9923L145.225 50.5051C145.293 50.5729 145.332 50.6652 145.332 50.7615C145.332 50.8578 145.293 50.9501 145.225 51.0179L141.52 54.7301Z"
          fill="#696E7C"
        />
      </g>
      <rect
        x="37.3611"
        y="39.3611"
        width="117.722"
        height="25.2778"
        rx="1.08333"
        stroke="#BDD2FF"
        strokeWidth="0.722222"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd"
        x="15.7514"
        y="4.37569"
        width="181.215"
        height="108.729"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.453039" />
        <feGaussianBlur stdDeviation="0.679558" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.172549 0 0 0 0 0.196078 0 0 0 0 0.258824 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.62431" />
        <feGaussianBlur stdDeviation="3.62431" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.172549 0 0 0 0 0.196078 0 0 0 0 0.258824 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow"
          result="effect2_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow"
          result="shape"
        />
      </filter>
      <clipPath id="clip0">
        <rect width="164" height="96" rx="4" fill="white" />
      </clipPath>
      <clipPath id="clip1">
        <rect
          width="101.111"
          height="18.7778"
          fill="white"
          transform="translate(48.5555 41.8889)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SingleSelect;
